import i18n from "i18next";

export {
  haveSSO,
  authenticate,
  sso,
  logOut,
  setAuth,
  refreshToken,
  getCompanies,
  setCompany,
} from "actions/authenticate";
export { getAnnouncements } from "actions/announcement";
export { getIntroVideos } from "actions/introVideos";
export { getFile } from "actions/file";
export { getFaq } from "actions/faq";
export { getGuide } from "actions/guide";
export { getInvoices, exportInvoice, getapplicantInvoices, exportapplicantInvoice, getemployeeInvoices, exportemployeeInvoice } from "actions/invoices";
export {
  getOrganisationActivities,
  getMyTeam,
  getMyTeamExport,
} from "actions/organisation";
export { getCalendar, getSuggestedTrainings } from "actions/calendar";
export { getDealerInfo } from "actions/dealer";
export {
  getEvolutionPlanEmployees,
  getEvolutionPlanCompletionRatio,
  getEvolutionPlanTrainingPreRequisites,
  getEvolutionPlans,
} from "actions/evolutionplan";

export {
  getNotifications,
  markNotificationAsSeen,
} from "actions/notifications";
export {
  getProfileGeneral,
  getProfileDetail,
  updateProfile,
  updateProfileImage,
  approveKvkk,
  getMailMatrix,
  sendEmailNotification,
  checkEmailCode,
  checkMobileCode,
  checkPersonalCellPhoneCode,
  sendMobileNotification,
  resetPassword,
  saveNewPassword,
} from "actions/profile";
export {
  getTrainings,
  getTrainingDetail,
  changeSelectedTrainingType,
  getTrainingDocuments,
  getTrainingParticipationRules,
  createRegistrationInformationalVideos,
  approveTrainingRequest,
  cancelEmployeeRegistrationTraining,
  createEmployeeRegistrationTraining,
  createTrainingRequest,
  doPlanTrainingRequest,
  rejectTrainingRequest,
  getCertificate,
  potentialTraningsExport,
  getAllRegisteredTrainings,
  allRegisteredTrainingsExport,
  getTrainingRequests,
  getInformationalVideos,
  getVideoCategories,
} from "actions/training";

export {
  getTotalEmployeeStats,
  getTrainingCompletenessStats,
  getEmployeeTurnoverStats,
  getELearningCompletenessStats,
} from "actions/stats";

export { getCompetency } from "actions/competency";

export {
  getEmployeeRoles,
  upsertEmployeeRole,
  cancelEmployeeRole,
} from "actions/employeeRoles";

export { getPositionRoles } from "actions/positionRoles";

export const showModal = (payload) => {
  return {
    type: "SHOW_MODAL",
    payload: payload,
  };
};

export const hideModal = () => {
  return {
    type: "HIDE_MODAL",
  };
};

export const setLanguage = (lang) => {
  return async (dispatch) => {
    await i18n.changeLanguage(lang).then(() => {
      dispatch({
        type: "SET_LANGUAGE_SUCCESS",
        payload: lang,
      });
    });
  };
};
